import Fade from "@mui/material/Fade";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Stack from "@mui/material/Stack";
import { Snackbar } from "@mui/material";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { Controller, useForm, useFieldArray } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import {
  FormGroup,
  TextField,
  InputLabel,
  MenuItem,
  InputAdornment,
  OutlinedInput,
  FormControl,
  Button,
  Box,
  Select,
  Typography,
  FormControlLabel,
  FormLabel,
  Divider,
  FormHelperText,
} from "@mui/material";

import {
  labelStyled,
  groupStyled,
  row,
  col,
  formGroupContainer,
  header,
  leftCol,
} from "../../components/400/styles";
import {
  AirlineSeatIndividualSuite,
  SettingsInputComponent,
} from "@mui/icons-material";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

// const api = axios.create({
//     baseURL: "http://localhost:5000/api/"
// })

const schema = yup.object().shape({
  academic_year: yup.string().required("Academic year required"),
  // semester_term : yup.number().required("semester term required"),
  start_date: yup
    .date()
    .transform((curr, orig) => (orig === "" ? null : curr))
    .required("start date required"),
  end_date: yup
    .date("input must be type date")
    .required("End date is required")
    .transform((curr, orig) => (orig === "" ? null : curr))
    .nullable()
    .when("start_date", (start_date) => {
      if (start_date) {
        return yup
          .date()
          .min(start_date, "End date must be after start date")
          .typeError("alalallala");
      }
    })
    .default(undefined),
});

export default function UpdateSemester() {
  const api = useAxiosPrivate();
  const [open, setOpen] = useState(false);
  const [successOpen, setSuccessOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const updateId = location.state.updateId;

  const {
    register,
    control,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: { semester_term: "I" },
    resolver: yupResolver(schema),
  });
  const getSemester = async () => {
    const result = await api.get(`getOneSemester/${updateId}`);
    console.log(result.data[0].academic_year);
    setValue("academic_year", result.data[0].academic_year);
    setValue("semester_term", result.data[0].semester_term);
    console.log(result.data[0].semester_term);
    const start = result.data[0].start_date.substring(
      0,
      result.data[0].start_date.indexOf("T")
    );
    const end = result.data[0].end_date.substring(
      0,
      result.data[0].end_date.indexOf("T")
    );
    setValue("start_date", start);
    setValue("end_date", end);
  };
  useEffect(() => {
    getSemester();
  }, [""]);

  const onSub = async (data) => {
    const a = data.start_date.toString();
    const b = a.split(/(\s+)/);
    console.log(b, b.length);
    let amt = [];
    let amt1 = "";
    for (let i = 2; i <= 6; i = i + 2) {
      amt.push(b[i]);
    }
    for (let i = 0; i < amt.length; i++) {
      amt1 = amt.join("/");
    }

    const numOfWeek = Math.round(
      (data.end_date - data.start_date) / (7 * 24 * 60 * 60 * 1000)
    );

    const result = await api.put(`/updateSemester/${updateId}`, {
      academic_year: data.academic_year,
      semester_term: data.semester_term,
      start_date: amt1,
      end_date: data.end_date,
      no_weeks: numOfWeek,
    });
    console.log(result);
    if (result.data.length > 0) setSuccessOpen(true);
  };
  return (
    <div>
      <form width="100px" onSubmit={handleSubmit(onSub)}>
        <Box sx={header}>
          <Typography
            variant="span"
            sx={{
              fontSize: "1.14rem",
              fontWeight: "600",
              lineHeight: "23.2px",
              color: "primary.main",
              mb: 5,
              mt: 2,
            }}
          >
            update Semester
          </Typography>
        </Box>
        <Box sx={formGroupContainer}>
          <Box sx={leftCol}>
            <FormControl sx={groupStyled}>
              <FormLabel sx={labelStyled}>Academic Year</FormLabel>
              <TextField
                id="year"
                name="batch_year"
                {...register("academic_year")}
                fullWidth
                error={errors.academic_year ? true : false}
              />
              <FormHelperText>
                {errors.academic_year && "academic year required"}
              </FormHelperText>
            </FormControl>

            {/*
          <FormControl>
                <FormLabel sx={labelStyled}>Semester Term</FormLabel>
                <TextField
                    name="semester_term"
                    {...register("semester_term")}
                    fullWidth
                    error = {errors.semester_term ? true : false}               
                />
                <FormHelperText>{errors.semester_term && "semester term required"}</FormHelperText>
          </FormControl> 
          */}

            <FormControl>
              <FormLabel sx={labelStyled}>semester term</FormLabel>
              <Controller
                control={control}
                name="semester_term"
                render={({ field }) => (
                  <>
                    <Select {...field}>
                      <MenuItem value="I">I</MenuItem>
                      <MenuItem value="II">II</MenuItem>
                      <MenuItem value="summer">summer</MenuItem>
                    </Select>
                  </>
                )}
              />
            </FormControl>

            <FormControl>
              <FormLabel sx={labelStyled}>start date</FormLabel>
              <TextField
                name="start_date"
                type="date"
                {...register("start_date")}
                fullWidth
                error={errors.start_date ? true : false}
              />
              <FormHelperText>
                {errors.start_date && "start date required"}
              </FormHelperText>
            </FormControl>

            <FormControl>
              <FormLabel sx={labelStyled}>end date</FormLabel>
              <TextField
                name="end_date"
                type="date"
                {...register("end_date")}
                fullWidth
                error={errors.end_date ? true : false}
              />
              <FormHelperText>
                {errors.end_date && "length of semester required"}
              </FormHelperText>
            </FormControl>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            gap: "1.8rem",
            justifyContent: "flex-end",
            width: "100%",
          }}
        >
          <Button
            variant="outlined"
            sx={{
              backgroundColor: "teritiary.lighter1",
              "&:hover": {
                backgroundColor: "teritiary.main",
              },
            }}
            onClick={() => {
              navigate("/calendar_management");
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "secondary.lighter1",
              "&:hover": {
                backgroundColor: "secondary.main",
              },
            }}
            type="submit"
            onClick={() => {
              console.log("clicked");
            }}
          >
            update
          </Button>
        </Box>
      </form>
      <Stack sx={{ width: "100%" }} spacing={2}>
        <Fade
          in={open}
          timeout={{ enter: 1000, exit: 1000 }}
          addEndListener={() => {
            setTimeout(() => {
              setOpen(false);
            }, 6000);
          }}
        >
          <Alert severity="error">
            <AlertTitle>Error</AlertTitle>
            semester already created
          </Alert>
        </Fade>
      </Stack>
      <Stack sx={{ width: "100%" }} spacing={2}>
        <Fade
          in={successOpen}
          timeout={{ enter: 1000, exit: 1000 }}
          addEndListener={() => {
            setTimeout(() => {
              setSuccessOpen(false);
              navigate("/calendar_management");
            }, 3000);
          }}
        >
          <Alert>
            <AlertTitle>Success</AlertTitle>
            semester successfully updated
          </Alert>
        </Fade>
      </Stack>
    </div>
  );
}
